import { handleActions } from 'redux-actions';
import { omit } from 'lodash';
import { removeUser, setUserById, setUsers } from './actions';
import { hashById } from '../../../util/helpers';

const defaultState = {};

export const reducer = handleActions(
  {
    [setUsers]: (state, action) => {
      const users = action.payload;
      return hashById(users);
    },
    [setUserById]: (state, action) => {
      const user = action.payload;
      return {
        ...state,
        [user.id]: user,
      };
    },
    [removeUser]: (state, action) => {
      const id = action.payload;
      return omit(state, [id]);
    },
  },
  defaultState,
);

export default reducer;



// WEBPACK FOOTER //
// ./src/lib/dataLayer/user/reducer.js